module.exports = __webpack_public_path__ + "static/media/SupplyChain2.36772d63.png";